import script from "./PointsDetails.vue?vue&type=script&setup=true&lang=ts"
export * from "./PointsDetails.vue?vue&type=script&setup=true&lang=ts"

import "./PointsDetails.vue?vue&type=style&index=0&id=1ff54d31&scoped=true&lang=scss"

import exportComponent from "/opt/jenkins/workspace/Application deploy/prod-fe-cn-social-media-wph-h5-deployment/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ff54d31"]])

export default __exports__